import { flushSync } from 'react-dom';
import React, { useState, useEffect, useContext } from 'react';
import SectionsSelect from '../../SectionsSelect'
import { ShopContext } from '../../contexts/Shop'
import { CustomerContext } from '../../contexts/Customer'
import { EnrollmentsContext } from '../../contexts/yolk/Enrollments'
import { SectionsContext } from '../../contexts/yolk/Sections'
import {FormProvider} from '@thinkwell/react.common'
import {EditModal} from '@thinkwell/react.polaris'
import {HostContext} from '../../contexts/Host'

export default function EditRetake(props) {
  const host = useContext(HostContext)
  const shop_name = useContext(ShopContext)
  const [customer] = useContext(CustomerContext)
  const [sections, fetchSections] = useContext(SectionsContext)
  const [enrollments, fetchEnrollments, fetchEnrollmentsState, upsertEnrollment] = useContext(EnrollmentsContext)

  const onActive = async(active, form) => {
    if(active) {
      const url = `${host}/accounts/enrollments/${props.id}/sections/retake.json?shop_name=${shop_name}`
      const sections = await fetchSections(url)
      const sectionId = form.field('section_id')
      const section = sectionId && (sections || []).find((section) => sectionId == section.id)
      if ((sections || []).length && !section) {
        console.log(`select first section ${sections[0].id} ${sectionId ? `(from ${sectionId})` : ''}`)
        flushSync(() => {
          form.onData('section_id')(sections[0].id)
        })
      }
    }
  }

  const url = (form) => {
    const urlPath = `enrollments/${props.id}/sections/${form.field('section_id')}/retake.json`
    return `${host}/accounts/${urlPath}?shop_name=${shop_name}&cid=${customer.id}`
  }

  const data = {
    section_id: props.sectionId
  }

  return (<FormProvider data={data}><EditModal
    active={props.active}
    onActive={onActive}
    onSave={upsertEnrollment}
    onSaving={props.onSaving}
    url={url}
    linkText='Retake this class'
    title="Retake this class"
    saveText="Retake">
    <SectionsSelect required
      notFoundMessage="There are no classes available for registration." />
  </EditModal></FormProvider>);
}
